import {
  ACCOUNT_OTP_CLOSE_MODAL,
  ACCOUNT_OTP_GET_TYPE,
  ACCOUNT_OTP_INIT_DATA_FOR_OTP_FORM,
  ACCOUNT_OTP_SENT,
  ACCOUNT_OTP_SHOW_MODAL,
  ACCOUNT_OTP_VERIFY,
  ACCOUNT_TOKENCA_VERIFY,
  CONFIRM_DEBT_SHOW_MODAL_AFTER_CLOSE_OTP,
  CONFIRM_DEBT_SHOW_MODAL_CLOSE,
  DISPATCH_CHANNEL_ID_TO_STORE,
  DISPATCH_POP_UPTO_STORE,
  POP_UP_SLIDE_MODAL_CLOSE,
} from 'redux/actions';
import { IAction } from 'interfaces/common';
import { IChannelID, IOtp, IPopUpData } from 'interfaces/reducers';
import { ISentOtp, IVerifyOtpRequest, IVerifyTokenCARequest } from 'interfaces/api';

export const initDataForOtpForm = (): IAction<Partial<IOtp>> => ({
  type: ACCOUNT_OTP_INIT_DATA_FOR_OTP_FORM,
  payload: {},
});

export const queryOtpType = (): IAction<Partial<IOtp>> => ({
  type: ACCOUNT_OTP_GET_TYPE,
  payload: {},
});

export const openOtpModal = (): IAction<Partial<IOtp>> => ({
  type: ACCOUNT_OTP_SHOW_MODAL,
  payload: {},
});

export const closeOtpModal = (): IAction<Partial<IOtp>> => ({
  type: ACCOUNT_OTP_CLOSE_MODAL,
  payload: {},
});

export const verifyOtp = (
  payload: IVerifyOtpRequest
): IAction<Partial<IVerifyOtpRequest>> => ({
  type: ACCOUNT_OTP_VERIFY,
  payload,
});

export const verifyTokenCA = (
  payload: IVerifyTokenCARequest
): IAction<Partial<IVerifyTokenCARequest>> => ({
  type: ACCOUNT_TOKENCA_VERIFY,
  payload,
});

export const sentOtp = (
  payload?: Pick<ISentOtp, 'matrixId' | 'isOtpOneModal' | 'forceSMS'>
): IAction<Partial<ISentOtp>> => ({
  type: ACCOUNT_OTP_SENT,
  payload: payload ?? {},
});

export const closeConfirmDebtModal = () => ({
  type: CONFIRM_DEBT_SHOW_MODAL_CLOSE,
  payload: {},
});
export const closePopUpSlideModal = () => ({
  type: POP_UP_SLIDE_MODAL_CLOSE,
  payload: {},
});

export const closeOtpModalAndTriggerConfirmDebt = () => ({
  type: CONFIRM_DEBT_SHOW_MODAL_AFTER_CLOSE_OTP,
  payload: {},
});
export const dispatchPopUptoStore = (payload: IPopUpData) => ({
  type: DISPATCH_POP_UPTO_STORE,
  payload,
});

export const dispatchChannelIDtoStore = (payload: IChannelID[]) => ({
  type: DISPATCH_CHANNEL_ID_TO_STORE,
  payload,
});



// WEBPACK FOOTER //
// ./src/redux/global-actions/Otp.ts